// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"881eb942","937":"bed58e60"}[chunkId] + ".chunk.js";
};